import { Injectable } from '@angular/core';
import { Models } from '@ibexfusion/models';

import { RestProvider, RestService } from '../rest/rest.service';
import { RestfulService } from '../rest/restful';

@Injectable()
export class AngieScreensService extends RestfulService<Models.AngieScreen> {

  constructor(public restService: RestService) {
    super(Models.AngieScreen);
    super.init();
  }

  public createProvider(): RestProvider {
    return this.restService.createProvider('angie-screens');
  }

}
